/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect, useState } from "react";

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// NewUser page components
import FormField from "views/users/account/components/BasicInfo/FormField";


function Password({ formData, informParent }) {
  const { formField, values, errors, touched } = formData;
  const { password, repeatPassword } = formField;
  const { password: passwordV, repeatPassword: repeatPasswordV } = values;

  const [passwordType, setPasswordType] = useState(true);
  const [repeatPasswordType, setRepeatPasswordType] = useState(true);

  const handlePasswordType = () => {
    setPasswordType((currentType) => !currentType);
  };

  const handleRepeatPasswordType = () => {
    setRepeatPasswordType((currentType) => !currentType);
  };

  useEffect(() => {
    //console.log("password form changed: ", touched);
    if (Object.keys(touched).length > 0) informParent(true);
  }, [touched]);

  return (
    <SoftBox>
      <SoftBox>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={7}>
            <Grid item xs={12} sm={12}>
              <FormField
                type={passwordType ? password.type : "text"}
                label={password.label}
                name={password.name}
                value={passwordV}
                placeholder={password.placeholder}
                error={errors.password && touched.password}
                success={passwordV.length > 0 && !errors.password}
                icon={{
                  component: passwordType ? "visibility_icon" : "visibility_off_icon",
                  direction: "right",
                }}
                iconaction={handlePasswordType}
                inputProps={{ autoComplete: "new-password" }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormField
                type={repeatPasswordType ? repeatPassword.type : "text"}
                label={repeatPassword.label}
                name={repeatPassword.name}
                value={repeatPasswordV}
                placeholder={repeatPassword.placeholder}
                error={errors.repeatPassword && touched.repeatPassword}
                success={repeatPasswordV.length > 0 && !errors.repeatPassword}
                icon={{
                  component: repeatPasswordType ? "visibility_icon" : "visibility_off_icon",
                  direction: "right",
                }}
                iconaction={handleRepeatPasswordType}
                inputProps={{ autoComplete: "new-password" }}
              />
            </Grid>
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

// typechecking props for UserInfo
Password.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  informParent: PropTypes.func,
};

export default Password;
